import React from 'react';
import { createSelectorHook, createDispatchHook, createStoreHook } from 'react-redux';

const FronteggStoreContext = React.createContext(null);
const useSelector = createSelectorHook(FronteggStoreContext);
const useDispatch = createDispatchHook(FronteggStoreContext);
const useStore = createStoreHook(FronteggStoreContext);

export { FronteggStoreContext as F, useDispatch as a, useStore as b, useSelector as u };
